import { Alert, Button } from "../ui";
import type { OperationEntry } from "./operationStore";
import { useUiText } from "../ui/uiText";

/** Only failed reads are offered again; this surface never replays the write or its follow-up actions. */
export function OperationFailures({ entries, retry, errorLabel, retryLabel }: {
  entries: readonly OperationEntry[];
  retry: (id: symbol) => Promise<void>;
  errorLabel?: string;
  retryLabel?: string;
}) {
  const { text } = useUiText();
  const failures = entries.filter(entry => entry.phase === "refreshFailed");
  const retryable = failures.filter(entry => entry.retryable !== false);
  return failures.length ? <Alert type="error" showIcon message={failures.some(entry => entry.writeUncertain) ? text("Write outcome uncertain") : failures.some(entry => entry.writeRejected) ? text("Rejected action refresh failed") : errorLabel ?? text("Data refresh failed")}
    action={retryable.length ? <Button onClick={async () => { await Promise.all(retryable.map(entry => retry(entry.id))); }}>{retryLabel ?? text("Refresh data")}</Button> : undefined} /> : null;
}
